export default __webpack_public_path__ + "static/media/killer_gf_03.7a130dbc.jpg";